module.exports = "<div class=breadcrumb__item ng-repeat=\"item in $ctrl.items track by $index\" ng-click=\"$ctrl.onBreadcrumbClick()($ctrl.items, item)\"> {{item.label || item.value || item.name || (item.slug | translate)}} </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/breadcrumb/breadcrumb.template.html
// module id = 556
// module chunks = 0